__turbopack_context__.v({
  "chevron-left-icon": "ChevronLeft-module-scss-module__Y_cpUa__chevron-left-icon",
});
